import Vue from 'vue'
import App from './App.vue'
import router from './router';
import i18n from './i18n';

Vue.config.productionTip = false
// 关闭浏览器「滚动位置自动恢复」，确保切换语言整页 reload 后从顶部开始（而非停留在原滚动位置）
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}
// ElementUI 按需引入（仅注册实际用到的组件，减小 bundle；需先 npm install babel-plugin-component）
import {
    Container, Header, Main, Footer,
    Breadcrumb, BreadcrumbItem,
    Card, Button, Image, Pagination,
    Carousel, CarouselItem,
    Form, FormItem, Input,
    Upload, Divider,
    Dropdown, DropdownMenu, DropdownItem,
    Drawer,
    Message
} from 'element-ui';

Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Card);
Vue.use(Button);
Vue.use(Image);
Vue.use(Pagination);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Upload);
Vue.use(Divider);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Drawer);
// JS 调用的 Message（this.$message 依赖此挂载）
Vue.prototype.$message = Message;

// 全局设计变量与通用类（统一品牌色/字体/布局）
import '@/assets/styles/global.scss';

import { isMobile } from '@/utils/device'
Vue.prototype.$isMobile = isMobile

// 设备类型跨越时自动刷新，保证 PC/移动端实时切换
let lastIsMobile = isMobile();
let resizeTimer = null;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        const now = isMobile();
        if (now !== lastIsMobile) {
            lastIsMobile = now;
            window.location.reload();
        }
    }, 300);
});

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// Vue.use(VueAwesomeSwiper)
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import VueRouter from 'vue-router'
Vue.use(VueRouter);
// 启动初期读取 URL 上的 ?lang 参数，使 index.html 的 hreflang 多语言落地页真正生效
// （hreflang 指向 ?lang=xx，但应用原先只认 sessionStorage，导致多语言 SEO 信号失效）
(function syncLangFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang');
    const MAP = {en: 'en-US', zh: 'zh-CN', ar: 'ar-SA', es: 'es-ES', ru: 'ru-RU', pt: 'pt-PT'};
    if (lang && MAP[lang]) {
        const locale = MAP[lang];
        sessionStorage.setItem('lang', locale);
        i18n.locale = locale;
    }
})();

new Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app')
